import { useQuery } from "@tanstack/react-query";
import { api } from "../utils/api";

const getStatuses = ({ categoryId }) => api.get(`/lead-statuses/?category_id=${categoryId}`).then(res => res.data);

export default function useStatuses({ categoryId }) {
  return useQuery({ queryKey: ['statuses', categoryId ], queryFn: () => getStatuses({ categoryId }) });
}
